var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-main-inner',{attrs:{"title":"概况统计"}},[_c('overview-data'),_c('overview-time-data')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }